// sai's showreels (DemoVideo.jsx), compressed to a few MB each and served from
// public/demo/video. Nothing loads until it is needed; the poster shows until
// then. Played by AutoVideo / Showcase.
export const VIDEOS = {
  // The Smart Report showreel (v2), 30 seconds with sound. Smart Reports page only.
  smartReportShowreel: {
    title: 'Smart Report showreel',
    length: '0:30',
    wide: { src: '/demo/video/smart-report-showreel-v2.mp4', poster: '/demo/video/smart-report-showreel-v2.jpg' },
  },
  // The Corporate Wellness Dashboard showreel, 30 seconds with sound.
  corporateShowreel: {
    title: 'Corporate wellness dashboard showreel',
    length: '0:30',
    wide: { src: '/demo/video/corporate-showreel.mp4', poster: '/demo/video/corporate-showreel.jpg' },
  },
  // The Corporate Wellness Dashboard's full walkthrough, 1 minute 25 with sound.
  // Click-to-play only (Corporate.jsx's "Watch the full walkthrough" dialog),
  // never autoplayed: not played by AutoVideo/Showcase.
  corporateExplainer: {
    title: 'Corporate Wellness Dashboard — full walkthrough',
    length: '1:25',
    wide: { src: '/demo/video/corporate-explainer.mp4', poster: '/demo/video/corporate-explainer.jpg' },
  },
  // The Viz App ("Smart App") showcase, 30 seconds with sound.
  vizShowcase: {
    title: 'Viz App showcase',
    length: '0:30',
    wide: { src: '/demo/video/viz-showcase.mp4', poster: '/demo/video/viz-showcase.jpg' },
  },
};
